<script setup lang="ts">
import Hero from '@/domains/investor/components/Hero/Hero.vue'

</script>

<template>
  <Hero
    image="/images/investor/presentations/presentations.png"
    :title="$t('aboutCompany.hero.title')"
    :lead="$t('aboutCompany.hero.lead')"
    :first-button="{
      text: $t('aboutCompany.hero.firstButton.text'),
      to: $t('aboutCompany.hero.firstButton.url'),
    }"
    :second-button="{
      variant: 'secondary',
      text: $t('aboutCompany.hero.secondButton.text'),
      to: $t('aboutCompany.hero.secondButton.url'),
    }"
  />
</template>
